export default "__VITE_ASSET__luWMwJKK__"